
    // ...existing code...
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { UserModel } from '../../shared/models/user.model';
import { CourtPopupComponent } from '../../shared/components/court-popup/court-popup.component';
import { Court } from '../../shared/models/court.model';
import { CoreService } from '../../shared/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { UpdateProfileComponent } from '../../shared/components/update-profile/update-profile.component';

import { BreadcrumbService } from '../../shared/services/breadcrumb.service';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnInit {
  userDetails: UserModel = new UserModel();
  isShowUser: boolean = false;
  isMobileMenuActive = false;
  isMobileUserSheet: boolean = false; 
  isDesktop: boolean;
  searchText: string = '';
  isShowNotifications: boolean = false;
  isSearchActive: boolean = false;
    window = window;

  constructor(
    private authService: AuthService,
    public router: Router,
    private dialog: MatDialog,
    public coreService: CoreService,
    private cdr: ChangeDetectorRef,
    public breadcrumbService: BreadcrumbService
  ) {
    this.isDesktop = window.innerWidth >= 768;
  }
  ngOnInit(): void {
  this.userDetails = this.authService.getUser();
  this.isDesktop = window.innerWidth >= 768;
}

@HostListener('window:resize', ['$event'])
onResize(event: any) {
  this.isDesktop = event.target.innerWidth >= 768;
}


  openCourtPopup() {
    const isMobile = window.innerWidth < 768; 

    const dialogRef = this.dialog.open(CourtPopupComponent, {
      width: isMobile ? '95vw' : '800px',  
      height: isMobile ? '90vh' : '800px', 
      maxWidth: '500px',  
      data: null,
      disableClose:true,
    });

    dialogRef.afterClosed().subscribe((result: Court) => {
      if (result) {
        this.createCourt(result);
      }
    });
  }
  showPopup(){
    const dialogRef = this.dialog.open(UpdateProfileComponent, {  
      data: this.userDetails,
      disableClose:true,
    });

    dialogRef.afterClosed().subscribe((result: UserModel) => {
      if (result) {
        this.userDetails=result

      }
    });
  }
  navigationToHome(){
    this.router.navigate(['/home']);
  }


 toggleMobileMenu() {
  this.coreService.isMobileMenuActive = 
    !this.coreService.isMobileMenuActive;
}

  createCourt(court: Court) {
    this.coreService.isLoading.next(true);
    this.coreService.postApi('/api/Court/CreateCourt', court).subscribe({
      next: (courtId: number) => {
        this.coreService.isLoading.next(false);
        if (courtId) {
            Swal.fire({
                      icon: "success",
                      title: "Created Successfully!",
                       toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 2200,
  timerProgressBar: true,
  background: 'var(--card-bg)',       
  color: 'var(--text-main)',             
  iconColor: 'var(--primary-blue)',        
  customClass: {
    popup: 'dk-toast'
  }
                })
        }
      },
      error: (error) => {
        this.coreService.isLoading.next(false);
        Swal.fire({
          icon: 'error',
          title:'Failed to create court. Please try again.', 
           toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 2200,
  timerProgressBar: true,
  background: 'var(--card-bg)',       
  color: 'var(--text-main)',             
  iconColor: 'var(--dk-orange)',        
  customClass: {
    popup: 'dk-toast'
  }
    })
      },
    });
  }

  toggleUserBtn() {
    if (window.innerWidth <= 768) {
      this.isMobileUserSheet = !this.isMobileUserSheet;
    } else {
      
      this.isShowUser = !this.isShowUser;
    }
  }

  toggleNotifications() {
    this.isShowNotifications = !this.isShowNotifications;
  }

  toggleLeftSidebar() {
    if (this.router.url === '/all-matches') {
      this.router.navigate(['/home']).then(() => {
        setTimeout(() => {
          this.coreService.setActiveSection('left');
        });
      });
    } else {
      setTimeout(() => {
        if (this.coreService.getActiveSection() === 'left') {
          this.coreService.setActiveSection('main');
        } else {
          this.coreService.setActiveSection('left');
        }
      });
    }
  }

  // toggleRightSidebar() {
  //   if(this.coreService.isMobileView()){
  //     this.router.navigate(['/all-matches']); 
  //     this.coreService.setActiveSection('main');
  //   }
      
  // }
  // togglePostPage() {
  //   this.coreService.setActiveSection('main');
  // }
  logOut() {
    this.coreService.isMobileMenuActive = false;
    this.authService.logOut();
    this.router.navigate(['/login']);
  }

  isLoginPage(): boolean {
    return this.router.url.includes('/login') || this.router.url.includes('/register');
  }

  goToMyClubs() {
  const isMobile = window.innerWidth <= 992;

  if (isMobile) {
    this.coreService.navigateToPage(['my-clubs']);
  } else {
    this.coreService.navigateToPage(['/home']);
  }

  this.coreService.isMobileMenuActive = false;
}
goToMyClubsLink() {
  this.coreService.navigateToPage(['/my-courts']);
  this.coreService.isMobileMenuActive = false;
}
goToMyMatchResultsLink() {
  this.coreService.navigateToPage(['/all-matches']);
  this.coreService.isMobileMenuActive = false;
}

  // Handle blur for search input field, but input should stay open if there is text
  onBlurSearch() {
    // Prevent the input from closing if there's text typed in it
    if (this.searchText.length === 0) {
      this.isSearchActive = false;
    }
  }

  // Toggle the search input visibility (for click event)
  toggleSearch() {
    if (window.innerWidth <= 768) {  // Apply only for mobile screens
      this.isSearchActive = !this.isSearchActive;
    } else {
      if (this.searchText.length === 0) {
        this.isSearchActive = !this.isSearchActive;
      }
    }
  }

  // Clear the search input field when "x" is clicked
  clearSearch() {
    this.searchText = ''; // Clears the search text
    this.isSearchActive = false; // Hide input box after clearing
  }

  // Close dropdowns when clicking outside
  @HostListener('document:click', ['$event'])
  closeDropdowns(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (
      !target.closest('.navright') &&
      !target.closest('.userdetails') &&
      !target.closest('.search-container')
    ) {
      this.isShowUser = false;
      this.isShowNotifications = false;
      // Ensure search input box remains open if text exists
      if (this.searchText.length === 0) {
        this.isSearchActive = false;
      }
    }
  }
}
